export default {"src":"/_next/static/media/member_since.790461dc.svg","height":50,"width":200,"blurWidth":0,"blurHeight":0};